import { stripHTML } from '~/utils/html';

export default {
  stripHTML: function (value) {
    if (!value) {
      return '';
    }
    value = value.toString();

    return stripHTML(value);
  },
  // NOTE: This should only be necessary when used in v-bind
  // {{ mustache }} templates offer automatic escaping
  escapeHTML: function (text) {
    return HubstaffUtils.escapeHTML(text);
  },
};
